/**
 * unaPorPersona — el 409 de «una por persona» (01/11), visto desde la pantalla.
 *
 * Al asignar a alguien que ya tiene una unidad del mismo tipo, el servidor responde 409 con
 * `details.code === 'una_por_persona'`:
 *   · modo «avisar»: `requiere_confirmacion: true` → se pregunta, y si se confirma se reenvía lo
 *     mismo con `confirmar_una_por_persona: true` (queda constancia en el historial);
 *   · modo «bloquear»: no se puede confirmar → se enseña el mensaje y ya.
 *
 * Inventario responde `{ error: <mensaje>, details }`; Incorporaciones, `{ error: 'inventario',
 * message, details }`. Esto lee los dos. Sin React ni red: lo prueba `unaPorPersona.test.js`.
 */

export const CAMPO_CONFIRMACION = 'confirmar_una_por_persona';

/**
 * Lee un error de axios. Devuelve null si no es el 409 de «una por persona»; si lo es:
 *   { confirmable, mensaje, pregunta, persona, ya_tiene }
 */
export function avisoUnaPorPersona(err) {
  const res = err && err.response;
  const data = res && res.data;
  const d = data && data.details;
  if (!res || res.status !== 409 || !d || d.code !== 'una_por_persona') return null;
  const refs = (d.ya_tiene || []).map((x) => x.referencia).filter(Boolean);
  const nombre = (d.persona && d.persona.nombre) || 'Esta persona';
  const tipo = d.tipo && d.tipo.nombre;
  const mensaje = (data.message && data.error === 'inventario' ? data.message : data.error) || data.message
    || `${nombre} ya tiene ${refs.join(', ')}.`;
  return {
    confirmable: !!d.requiere_confirmacion,
    mensaje,
    pregunta: `${nombre} ya tiene ${refs.join(', ') || 'otro'}${tipo ? ` («${tipo}»)` : ''}. `
      + '¿Asignar igualmente? Quedará anotado en el historial.',
    persona: d.persona || null,
    ya_tiene: d.ya_tiene || [],
  };
}
